


import Vue from 'vue'
import ExecutedQuantityTransformer from '@/transformers/purchase/executedQuantity'
import errorHandler from '@/utils/errorHandler'

export default (affectedId, concepts, realScope) => {
  const url = `purchase/real_executed_quantity/${affectedId}/`
  
  const payload = ExecutedQuantityTransformer.send({
    concepts,
    ...realScope
  })
  return Vue.$http.put(url, payload)
    .then(response => {
      const data = ExecutedQuantityTransformer.fetch(response.data)
      return data
    })
}



// WEBPACK FOOTER //
// ./src/services/purchase/sendRealQuantities.js